export default __webpack_public_path__ + "static/media/show.c52fd1ae.svg";